import { render, staticRenderFns } from "./MessageVehiculo.vue?vue&type=template&id=66f34fd8&scoped=true"
import script from "./MessageVehiculo.vue?vue&type=script&lang=js"
export * from "./MessageVehiculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f34fd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66f34fd8')) {
      api.createRecord('66f34fd8', component.options)
    } else {
      api.reload('66f34fd8', component.options)
    }
    module.hot.accept("./MessageVehiculo.vue?vue&type=template&id=66f34fd8&scoped=true", function () {
      api.rerender('66f34fd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Final/MessageVehiculo.vue"
export default component.exports